module.exports = __webpack_public_path__ + "img/symbol-calendar-right.280117ab.png";